"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RichNumberConverter = void 0;
var string_1 = require("@devexpress/utils/lib/utils/string");
var RichNumberConverter = (function () {
    function RichNumberConverter() {
    }
    RichNumberConverter.numberToBinary = function (num) {
        return (num >>> 0).toString(2);
    };
    RichNumberConverter.numberToHex = function (num) {
        return (num >>> 0).toString(16);
    };
    RichNumberConverter.convertToBinary = function (num) {
        return string_1.StringUtils.padLeft(RichNumberConverter.numberToBinary(num), 2, '0');
    };
    RichNumberConverter.convertToHexBinary = function (num) {
        return string_1.StringUtils.padLeft(RichNumberConverter.numberToHex(num), 8, '0');
    };
    return RichNumberConverter;
}());
exports.RichNumberConverter = RichNumberConverter;
